
/* eslint-disable max-len */
import 'react';
const RecommendReadingCloseSvg = () => (
    <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg"><path d="M6.77.16a.763.763 0 011.007 1.142L5.079 4l2.698 2.698A.763.763 0 016.769 7.84l-.071-.063L4 5.079 1.302 7.777l-.071.063A.763.763 0 01.223 6.698L2.921 4 .223 1.302A.763.763 0 011.231.16l.071.063L4 2.921 6.698.223z" fill="#878D99" /></svg>
);
export default RecommendReadingCloseSvg;
